import React, { useEffect, useRef, useState } from 'react';

export default function CommissionContractModal({ onClose, onConfirm }) {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#fff';
  }, []);

  const getCtx = () => canvasRef.current?.getContext('2d');

  const pointerPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    return { x, y };
  };

  const start = (e) => {
    setIsDrawing(true);
    const ctx = getCtx();
    const { x, y } = pointerPos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!isDrawing) return;
    const ctx = getCtx();
    const { x, y } = pointerPos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasSignature(true);
  };
  const end = () => setIsDrawing(false);

  const clear = () => {
    const ctx = getCtx();
    const canvas = canvasRef.current;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasSignature(false);
  };

  const handleConfirm = () => {
    if (!hasSignature) return;
    const dataUrl = canvasRef.current.toDataURL('image/png');
    onConfirm(dataUrl);
  };

  return (
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center bg-black/70 p-4">
      <div className="bg-slate-800 border border-slate-700 rounded-xl w-full max-w-2xl p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-white text-xl font-bold">Contrat de commission</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-white">✕</button>
        </div>
        <div className="bg-slate-700/40 border border-slate-600 rounded-lg p-4 text-slate-200 max-h-64 overflow-auto text-sm mb-4">
          <p>
            En choisissant le contrat de commission, vous acceptez un prélèvement de 10% sur chaque mission réalisée via la plateforme. Les paiements sont effectués après validation de la mission. Aucun engagement mensuel.
          </p>
        </div>
        <div className="mb-2 text-slate-300 text-sm">Signature électronique (tracez votre signature ci-dessous)</div>
        <div className="bg-slate-900 rounded-lg border border-slate-600">
          <canvas
            ref={canvasRef}
            className="w-full h-48 touch-none"
            onMouseDown={start}
            onMouseMove={move}
            onMouseUp={end}
            onMouseLeave={end}
            onTouchStart={start}
            onTouchMove={move}
            onTouchEnd={end}
          />
        </div>
        <div className="flex justify-between mt-3">
          <button onClick={clear} className="px-3 py-2 bg-slate-700 text-slate-200 rounded-md">Effacer</button>
          <div className="flex gap-3">
            <button onClick={onClose} className="px-4 py-2 rounded-md bg-slate-700 text-slate-200">Annuler</button>
            <button disabled={!hasSignature} onClick={handleConfirm} className={`px-4 py-2 rounded-md font-semibold ${hasSignature? 'bg-amber-500 text-slate-900' : 'bg-slate-600 text-slate-400 cursor-not-allowed'}`}>Signer et valider</button>
          </div>
        </div>
      </div>
    </div>
  );
}










